<template>
  <div class="portfolio-filter">
    <div class="container p-0">
      <b-row>
        <b-col cols="12" class="font-size-0 position-relative btns-wrapper mx-auto">
          <div class="text-center">
            <!-- <h2 :class="(idx_cat_selected == -1) ? 'cat-selected' : ''" class="mr-lg-4 d-lg-inline-block f-gotham d-block cat-btn mx-auto pt-lg-1 pb-lg-0 pl-lg-0 pr-lg-0 p-2 font-size-16 cursor-pointer cat-btn" v-on:click="idx_cat_selected = -1">{{'Todos'.toUpperCase()}}</h2> -->
            <h6 :class="(idx_cat_selected == idx) ? 'cat-selected' : ''" class="mr-lg-4 ml-lg-4 d-lg-inline-block f-gotham d-block cat-btn mx-auto pt-lg-1 pb-lg-0 pl-lg-0 pr-lg-0 p-2 cursor-pointer cat-btn" v-for="(cat, idx) in categories" v-on:click="idx_cat_selected = idx" :key="idx">{{cat.name_portfolio}}</h6>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="container mt-4 p-0">
      <b-row v-show="false" v-if="can_load_all"> <!-- LOAD ALL IMAGES SO IT DON'T TAKE TIME TO LOAD ON CATEGORY TOGGLE -->
        <b-col>
          <img v-for="(proj, idx) in projects" :key="proj.id" :alt="proj.thumbnail" :src="proj.thumbnail">
        </b-col>
      </b-row>
      <transition-group tag="b-row" class="position-relative items-wrapper mx-lg-auto" name="filter-ani" mode="out-in">
        <b-col xl="4" md="4" sm="6" class="item mt-3" v-for="(f_proj, idx) in filtered_projs" :key="f_proj.id">
          <router-link :to="{name: 'project', params: {lang: $route.params.lang, id: f_proj.id, slug: f_proj.slug}}" tag="div" class="item-link w-100 cursor-pointer">
              <div class="position-relative h-100" :style="'background-image: url(' +f_proj.thumbnail+ ');'">
                <div class="overlay-thumb text-center w-100 h-100 text-center p-3">
                  <div class="position-relative text-center w-100">
                    <h4 class="section-title line-up-white text-white d-inline-block">{{f_proj.abreviature}}</h4>
                    <p class="text-white">{{f_proj.teaser}}</p>
                  </div>
                </div>
              </div>
          </router-link>
        </b-col>
      </transition-group>
    </div>
  </div>
</template>
<script>
export default {
  name: 'porfolio-filter',
  props: ['projects', 'categories'],
  data() {
    return {
      idx_cat_selected: 0,
      cat_slugs: [],
      can_load_all: false
    }
  },
  computed: {
    filtered_projs: function() {
      if(this.idx_cat_selected === -1) {
        return this.projects;
      }
      return this.projects.filter((proj, idx) => proj.categories.indexOf(this.cat_slugs[this.idx_cat_selected]) !== -1);
    },
  },
  watch: {
  	idx_cat_selected: function(new_val, old_val) {
		let cat_slug = 'all';
		if(new_val !== -1) {
      cat_slug = this.cat_slugs[new_val];
  	}
		let new_url = window.location.href.replace(/\/[^\/]*$/, '/' +cat_slug); // replace last url segment
		window.history.pushState(null, null, new_url);
  	}
  },
  created() {
    this.cat_slugs = this.categories.map((val, idx) => val.slug);
    if(typeof this.$route.params.type !== 'undefined') {
      if(this.cat_slugs.indexOf(this.$route.params.type) !== -1) {
        this.idx_cat_selected = this.categories.findIndex((val, idx) => val.slug === this.$route.params.type);
      }
      else {
        // this.$router.push()
      }
      var that = this;
      setTimeout(() => that.can_load_all = true, 600);
    }
  }
}
</script>
<style scoped>

/* .cat-selected {
  color: #ffffff;
  background-color: #00263d;
}*/
/*.btns-wrapper {
  max-width: 2000px;
}*/
.items-wrapper {
  max-width: 700px;
}
.cat-btn {
  transition: all .2s;
  border-top-color: transparent;
}
.cat-selected, .cat-btn {
  border-top-style: solid;
  border-top-width: 3px;
}
.cat-selected {
  border-top-color: #00263d;
}
.item {
  transition: all .3s;
  /* background-image: url('https://img-aws.ehowcdn.com/877x500p/photos.demandstudios.com/getty/article/88/133/97787208.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  bacground-size: cover; */
}
.item-link {
  height: 150px;
}
.item-link > div {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.overlay-thumb {
  transition: all 0.25s ease-in-out;
  background-color: rgba(0, 0, 0, .5);
  opacity: 0;
}
.overlay-thumb > div {
  top: 60%;
  transform: translateY(-50%);
  transition: all 0.25s ease-in-out;
}
.item-link:hover .overlay-thumb {
  opacity: 1;
}
.item-link:hover .overlay-thumb > div {
  top: 50%;
}
.filter-ani-enter, .filter-ani-leave-to {
  opacity: 0;
  transform: scale(0);
}
.filter-ani-leave-active {
  position: absolute;
}
.filter-ani-enter img, .filter-ani-leave-to img {
  
}
@media (max-width: 991.98px) {
  .items-wrapper {
    max-width: none;
  }
  .cat-selected {
    background-color: #00263d;
    color: #ffffff;
  }
  .cat-btn {
    border: none;
  }
  .overlay-thumb {
    opacity: 1;
  }
  .overlay-thumb > div {
    top: 50%;
  }
}
@media screen and (max-width:767.98px) {
}
</style>
